module.exports = __webpack_public_path__ + "img/c3afb23.jpg";